import { useCallback, useMemo } from 'react';
import useTranslate from './useTranslate';

const prefix = 'common_txProduct_';

export const useProductMap = () => {
  const { getTranslation } = useTranslate();

  //! provide bilingual sheet for API_STATIC_VA, API_KYC, SCHEDULED_DISBURSE, API_OFFLINE, EWALLET_AGGREGATOR
  // To add a new product, add it to the last item of this array, the first item is reserved for default filter (ALL)
  const listProduct = useMemo(
    () => [
      'ALL',
      'API_BILLER',
      'API_DISBURSE',
      'API_INQUIRY',
      'API_STATIC_VA',
      'API_KYC',
      'API_OFFLINE',
      'ACCOUNT_PAYABLE_INVOICE',
      'ADJUSTMENT',
      'OPEN_BANKING',
      'BULK_DISBURSE',
      'EWALLET_AGGREGATOR',
      'MANUAL_ADJUSTMENT',
      'OFFLINE_-_CASH_IN',
      'OFFLINE_-_CASH_OUT',
      'OVERBOOKING_REFUND',
      'OVERDRAFT_ADJUSTMENT',
      'PAYMENT_CHECKOUT',
      'PENDING_ADJUSTMENT',
      'REFUND',
      'SCHEDULED_DISBURSE',
      'SERVICE_FEE',
      'TRANSACTION_DATA',
      'TOP_UP',
      'TRANSACTIONS_DATA',
      'VIRTUAL_ACCOUNT',
      'VIRTUAL_CREDIT_CARD',
      'WITHDRAWAL',
      'INTERNATIONAL_TRANSFER',
      'Frozen Balance',
      'DAILY_WITHDRAWAL',
    ],
    [],
  );

  const mapProduct = useCallback(
    (txProduct: string) => {
      let productTitle = txProduct;

      // Convert product key to match bilingual key
      switch (txProduct) {
        case 'TOPUP':
          txProduct = 'TOP_UP';
          break;
        case 'API DISBURSEMENT':
          txProduct = 'API_DISBURSE';
          break;
        case 'API_STATIC_VA':
          txProduct = 'VA_AGGREGATOR';
      }

      if (listProduct.includes(txProduct)) {
        txProduct = txProduct ? txProduct.toLowerCase().replace(/ /g, '_') : '';

        productTitle = getTranslation(`${prefix}${txProduct}`);
      }

      if (productTitle?.includes('_')) {
        return txProduct.replace(/_/g, ' ');
      }

      return productTitle;
    },
    [getTranslation, listProduct],
  );

  const txProducts = useMemo(
    () =>
      listProduct
        .map(e => ({
          value: e === 'ALL' ? '' : e,
          label:
            e === 'ALL'
              ? getTranslation(`common_all`).toUpperCase()
              : e === 'OFFLINE_-_CASH_IN'
              ? getTranslation(
                  `common_txProduct_offline_-_cash_in`,
                ).toUpperCase()
              : e === 'OFFLINE_-_CASH_OUT'
              ? getTranslation(
                  `common_txProduct_offline_-_cash_out`,
                ).toUpperCase()
              : mapProduct(e).toUpperCase(),
        }))
        .sort((a, b) => {
          if (a.value === '') return -1; // 'ALL' should always be at the top
          if (b.value === '') return 1; // 'ALL' should always be at the top
          return a.label.localeCompare(b.label); // Otherwise, sort by label
        }),
    [getTranslation, listProduct, mapProduct],
  );

  return { txProducts, mapProduct };
};
